import { inject, injectable } from 'tsyringe';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import { RecommendationConditions } from '../../datastore-service/models/conditions.model';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { Application } from '../../../models/application.model';
import { kNameOfRemoteObjectHttpFile } from '../../remote-object/remote-object-http-file';
import { IRemoteObject } from '../../remote-object/remote-object.interface';
import { LoggerService } from '../../logger.service';
import { IConfigurations } from '../../../interfaces/configurations.interface';
import { kDIConfigurations } from '../../../constants/injectionTokens';

export interface IGeoConfig {
  eligible: boolean;
}
// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.AppSpecific)
export class ConditionGeoRestricted implements ICondition {
  private readonly logger = LoggerService.getCategory('ConditionGeoRestricted');

  // ---------------------------------------------------------------------------
  public constructor(
    @inject(kNameOfRemoteObjectHttpFile)
    private readonly remoteObject: IRemoteObject,
    @inject(kDIConfigurations)
    private readonly configurations: IConfigurations,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const { application } = context;

    const match = await this.IsUserGeoAllowed(application);
    const reason = match ? null : NoRecommendationsReasons.GeoRestricted;
    return [match, reason];
  }

  // ---------------------------------------------------------------------------
  async shouldSkip(context: ConditionContext): Promise<boolean> {
    const { application } = context;
    if (!application.appConditions) {
      return true;
    }

    const hasCondition = application.appConditions.includes(
      RecommendationConditions.ConditionGeoRestriction,
    );

    return !hasCondition;
  }

  // ---------------------------------------------------------------------------
  private async IsUserGeoAllowed(application: Application): Promise<boolean> {
    await this.remoteObject.initialize(
      `${this.configurations.generalConfiguration.geoConditionURL}` +
        `${application.uid}`,
    );

    const [geoConfig] = await this.remoteObject.retrieve<IGeoConfig>();
    if (!geoConfig) {
      return false;
    }

    return geoConfig.eligible;
  }
}
